/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { AccessRequestApprovalType } from './AccessRequestApprovalType';
import {
    AccessRequestApprovalTypeFromJSON,
    AccessRequestApprovalTypeFromJSONTyped,
    AccessRequestApprovalTypeToJSON,
    AccessRequestApprovalTypeToJSONTyped,
} from './AccessRequestApprovalType';

/**
 * 
 * @export
 * @interface PermissionCreateRequest
 */
export interface PermissionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionCreateRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionCreateRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionCreateRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionCreateRequest
     */
    tags?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof PermissionCreateRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionCreateRequest
     */
    canBeRequestedByUsers?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PermissionCreateRequest
     */
    organizationGroupId?: any | null;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof PermissionCreateRequest
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionCreateRequest
     */
    requireUserOrganizationInMinSide?: boolean | null;
    /**
     * 
     * @type {AccessRequestApprovalType}
     * @memberof PermissionCreateRequest
     */
    accessRequestApprovalType?: AccessRequestApprovalType;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionCreateRequest
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PermissionCreateRequest
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionCreateRequest
     */
    requiresReasonForAsking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PermissionCreateRequest
     */
    helpTextReasonField?: string | null;
}



/**
 * Check if a given object implements the PermissionCreateRequest interface.
 */
export function instanceOfPermissionCreateRequest(value: object): value is PermissionCreateRequest {
    return true;
}

export function PermissionCreateRequestFromJSON(json: any): PermissionCreateRequest {
    return PermissionCreateRequestFromJSONTyped(json, false);
}

export function PermissionCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'tags': json['tags'] === undefined ? undefined : json['tags'] === null ? null : json['tags'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'canBeRequestedByUsers': json['canBeRequestedByUsers'] == null ? undefined : json['canBeRequestedByUsers'],
        'organizationGroupId': json['organizationGroupId'] === undefined ? undefined : json['organizationGroupId'] === null ? null : json['organizationGroupId'],
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': json['requireUserOrganizationInMinSide'] === undefined ? undefined : json['requireUserOrganizationInMinSide'] === null ? null : json['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': json['accessRequestApprovalType'] == null ? undefined : AccessRequestApprovalTypeFromJSON(json['accessRequestApprovalType']),
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
        'helpTextReasonField': json['helpTextReasonField'] === undefined ? undefined : json['helpTextReasonField'] === null ? null : json['helpTextReasonField'],
    };
}

export function PermissionCreateRequestToJSON(json: any): PermissionCreateRequest {
    return PermissionCreateRequestToJSONTyped(json, false);
}

export function PermissionCreateRequestToJSONTyped(value?: PermissionCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortName': value['shortName'],
        'description': value['description'],
        'applicationId': value['applicationId'],
        'tags': value['tags'],
        'userType': UserTypeToJSON(value['userType']),
        'canBeRequestedByUsers': value['canBeRequestedByUsers'],
        'organizationGroupId': value['organizationGroupId'],
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': value['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': AccessRequestApprovalTypeToJSON(value['accessRequestApprovalType']),
        'requiresMfa': value['requiresMfa'],
        'accessExpirationId': value['accessExpirationId'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
        'helpTextReasonField': value['helpTextReasonField'],
    };
}

